<div class="dialog-header">
  <h2 mat-dialog-title>Cancel Transaction Request</h2>
  <button mat-icon-button class="close-button" (click)="onCloseClick()" [disabled]="isSubmitting" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <p>Are you sure you want to cancel this request?</p>
</mat-dialog-content>

<mat-dialog-actions class="form-actions">
  <button mat-flat-button class="cancel-button" color="warn" [disabled]="isSubmitting" (click)="onYesClick()">
    @if (isSubmitting) {
      <mat-spinner [diameter]="20" color="warn"></mat-spinner>
    }
    @if (!isSubmitting) {
      <span>Yes, cancel request</span>
    }
  </button>
  <button mat-flat-button class="back-button" [disabled]="isSubmitting" (click)="onNoClick()">No, go back</button>
</mat-dialog-actions>
